import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
export const loadCmsIndex = createServerFn({ method: "GET" }).handler(
  async () => {
    try {
      return await (await import("./public.server")).publicIndex();
    } catch {
      return [];
    } // Existing pages remain available if the editorial backend is down.
  },
);
export const loadCmsPage = createServerFn({ method: "GET" })
  .inputValidator(z.string().max(240))
  .handler(async ({ data }) => {
    return (await import("./public.server")).publicPage(data);
  });
export const loadPublicOperations = createServerFn({ method: "GET" }).handler(
  async () => {
    try {
      return await (await import("./public.server")).publicOperations();
    } catch {
      return null;
    }
  },
);
